import { useEffect, useState } from 'react';
import { toast } from 'dash-ui';

import { CURRENCY_CONVERTER_URL } from './CurrencyConverterWidget.constants';

export const useGetCurrencyRateData = () => {
  const [timestamp, setTimestamp] = useState<number>(0);

  useEffect(() => {
    const ratesTimestamp = (localStorage.getItem('ratesTimestamp') ||
      0) as number;
    setTimestamp(ratesTimestamp * 1000);
  }, [setTimestamp]);

  return { timestamp };
};

export const useSetCurrencyRates = () => {
  const { timestamp } = useGetCurrencyRateData();
  const [rates, setRates] = useState<Record<string, number>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const diff = Date.now() - timestamp;
  const canRefetch = diff / (1000 * 60 * 60 * 24) > 1 && !!timestamp;

  useEffect(() => {
    const options = { method: 'GET', headers: { accept: 'application/json' } };

    if (canRefetch || !localStorage.getItem('ratesTimestamp')) {
      setLoading(true);
      fetch(CURRENCY_CONVERTER_URL, options)
        .then((response) => response.json())
        .then((data) => {
          setRates(data.rates);
          setLoading(false);
          localStorage.setItem('rates', JSON.stringify(data.rates));
          localStorage.setItem(
            'ratesTimestamp',
            JSON.stringify(data.timestamp)
          );
        })
        .catch((error) => toast.error(error.message));
    }
  }, [canRefetch]);

  useEffect(() => {
    setRates(JSON.parse(localStorage.getItem('rates') || '{}'));
  }, []);

  return { rates, loading };
};
